import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Login2.css";
import LogoTT from "../assets/images/LogoTT.png"; // NoteBar logo
import StudyImage from "../assets/images/interior2.jpg"; // Background image on the right
import GoogleLogo from "../assets/icons/google.webp"; // Google logo

const Login2 = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();

    // Authentication placeholder logic
    if (username && password) {
      console.log("User logged in:", username);
      navigate("/notebookhome");
    } else {
      alert("Please enter a username and password.");
    }
  };

  return (
    <div className="login-page">
      {/* Right-Side Background Image */}
      <img src={StudyImage} alt="College" className="right-image" />

      <div className="container">
        {/* Left Section */}
        <div className="left-section">
          <img src={LogoTT} alt="InsideBox Logo" className="logo-img" />

          <p className="subtitle">Welcome Back!</p>
          <h2 className="title">Sign In to NoteBar</h2>

          <div className="form-container">
            <form onSubmit={handleLogin}>
              <label className="label">Username</label>
              <input
                type="text"
                placeholder="Enter your username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="input"
              />

              <label className="label">Password</label>
              <input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input"
              />

              <button type="submit" className="btn">Sign In</button>
            </form>

            {/* Google Sign-In Button */}
            <button className="google-btn">
              <img src={GoogleLogo} alt="Google" className="google-icon" />
              Sign in with Google
            </button>
          </div>

          {/* Navigate to Signup Page */}
          <p className="signup-text">
            Don't have an account?{" "} 
            <span className="link" onClick={() => navigate("/signup")}>
              Sign Up
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login2;
